export const VERIFY_USER = 'verifyUser';
export const CONTACT_INFO = 'contactForm';
export const APPROVAL_FORM = 'approvalForm';
export const APPROVAL_VIEW = 'approvalView';
export const CONTACT_US_FORM = 'contactUsForm';
export const FILTER_FORM = 'filterForm';
export const SAMBANDH_APPROVAL_FORM = 'sambandhApprovalForm';
export const REJECT_SAMBANDH_FORM = 'rejectSambandhForm';
export const USER_PROFILE_FORM = 'userProfileForm';
export const ACCESS_FORM = 'accessForm';
